import { render, staticRenderFns } from "./VeHrKaoqinPersonRecordModal.vue?vue&type=template&id=65b4d170"
import script from "./VeHrKaoqinPersonRecordModal.vue?vue&type=script&lang=js"
export * from "./VeHrKaoqinPersonRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports